/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { IoMdAdd, IoMdArrowRoundBack } from "react-icons/io";
import { Modal } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  GetallSmsCampaignShortcuts,
  DeleteSmsCampaignShortcuts,
} from "../Features/SmscampaignShortcuts/Smscampaignshortcuts";
import { RootState, AppDispatch } from "../Appstore/store";
import { Toast } from "primereact/toast";
import { setIsLoading } from "../Features/loadingSlice";
import Addsmscampaignshortcuts from "./Addsmscampaignshortcutsmodal";
import { formatDate } from "../helper";
import Updatesmscampaignshortcuts from "./Updatesmscampaignshortcutsmodal";
import { toast } from "sonner";
import { RenderPaginationButtons } from "./Paginations";
import HelpText from "./HelpText";

interface SmsCampaignShortcuts {
  id: number;
  code: string;
  message: string;
  createdAt: string;
  updatedAt: string;
}

function Shortcuts({ record }: { record: SmsCampaignShortcuts }) {
  const [showAddShorcutsModal, setshowAddShorcutsModal] =
    useState<boolean>(false);
  const [showUpdateShorcutsModal, setUpdateShorcutsModal] =
    useState<boolean>(false);
  const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false);
  const [selectedId, setSelectedId] = useState<number | null>(null);
  const [search, setSearch] = useState<string>("");
  const [currentPage, setCurrentPage] = useState<number>(1);
  const limit = 10;
  const dispatch = useDispatch<AppDispatch>();
  const [debouncedSearch, setDebouncedSearch] = useState<string>(search);
  const navigate = useNavigate();

  const { smscampaignshortcutsdata, info, loading } = useSelector(
    (state: RootState) => state.smscampaignshortcuts
  );

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(search.trim());
    }, 800);

    return () => {
      clearTimeout(handler);
    };
  }, [search]);

  useEffect(() => {
    dispatch(
      GetallSmsCampaignShortcuts({
        search: debouncedSearch,
        page: currentPage,
        limit,
        sms_campaign_id: record.id,
      })
    );
  }, [dispatch, debouncedSearch, currentPage, limit, record]);

  const openDeleteModal = (id: number) => {
    setSelectedId(id);
    setShowDeleteModal(true);
  };

  const closeDeleteModal = () => {
    setShowDeleteModal(false);
    setSelectedId(null);
  };

  useEffect(() => {
    if (currentPage > info?.total_page!) setCurrentPage(info?.total_page || 1);
  }, [info]);

  const confirmDelete = async () => {
    if (selectedId !== null) {
      dispatch(setIsLoading(true));
      const resp: any = await dispatch(
        DeleteSmsCampaignShortcuts({ id: selectedId })
      );
      if (resp?.payload?.status === "success")
        toast.success(resp?.payload?.message || "");
      else toast.error(resp?.payload?.message || "");
      setTimeout(() => {
        dispatch(setIsLoading(false));
      }, 500);
      dispatch(
        GetallSmsCampaignShortcuts({
          search: "",
          page: 1,
          limit: 10,
          sms_campaign_id: record.id,
        })
      );
    }
    closeDeleteModal();
  };

  const handlePageChange = (page: number) => {
    if (page > 0 && page <= (info?.total_page || 1)) {
      setCurrentPage(page);
    }
  };

  const closeAddshortcutsrecordModal = () => {
    setshowAddShorcutsModal(false);
  };

  const Updateshortcutsrecord = (id: number) => {
    setUpdateShorcutsModal(true);
    setSelectedId(id);
  };

  const closeUpdateshortcutsrecordModal = () => {
    setUpdateShorcutsModal(false);
  };

  return (
    <div className="wrapper">
      <>
        <Modal show={showDeleteModal} onHide={closeDeleteModal} centered>
          <div className="p-3">
            <div className="text-center">
              <i
                style={{ fontSize: "50px" }}
                className="text-danger bi bi-info-circle"
              ></i>
            </div>
            <Modal.Header className="d-block border-0 p-2 text-center">
              <Modal.Title>Confirm Delete</Modal.Title>
            </Modal.Header>
            <Modal.Body className="border-0 text-center p-2">
              Are you sure you want to delete this SMS Campaign Shortcuts
            </Modal.Body>
            <Modal.Footer className="border-0 justify-content-center">
              <button className="btn btn-danger" onClick={confirmDelete}>
                Delete
              </button>
              <button className="btn btn-secondary" onClick={closeDeleteModal}>
                Cancel
              </button>
            </Modal.Footer>
          </div>
        </Modal>

        <Addsmscampaignshortcuts
          show={showAddShorcutsModal}
          onHide={closeAddshortcutsrecordModal}
          recordid={record.id}
        />

        <Updatesmscampaignshortcuts
          show={showUpdateShorcutsModal}
          onHide={closeUpdateshortcutsrecordModal}
          record={record}
          id={selectedId}
        />
      </>
      <div className="content-wrapper">
        <section className="content">
          <div className="container-fluid">
            <div className="card mt-4">
              <div className="card-header bg-white p-3 d-md-flex justify-content-md-between align-items-center">
                <h2 className="w-100 text-md-start text-center mb-md-2 mb-3 fs-3">
                  SMS Campaigns Shortcuts
                </h2>
                <div className="d-md-flex justify-content-between align-items-center mb-md-0 mb-3">
                  <div className="input-group input-group-sm pe-md-3 mb-md-0 mb-3 search-input-sms-campaign">
                    <input
                      type="search"
                      className="form-control float-right height-40px shadow-none"
                      placeholder="Search"
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                    />
                    <div className="input-group-append">
                      <button
                        type="submit"
                        className="btn border cursor-pointer-none"
                      >
                        <i className="fas fa-search" />
                      </button>
                    </div>
                  </div>
                  <div>
                    <button data-tooltip-id="Add_Btn" className="border-0 bg-button btn btn-primary text-white rounded-0  text-secondary w-100 px-2 py-2 fw-semibold d-flex justify-content-center align-items-center"
                      onClick={() => setshowAddShorcutsModal(true)}
                    >
                      <IoMdAdd className="fs-4" />
                      <HelpText id="Add_Btn" content="Add SMS Campaign Shortcut" />
                    </button>
                  </div>
                </div>
                <div className="d-md-block d-none ps-md-3">
                  <button
                    onClick={() => navigate(-1)}
                    className="btn btn-info text-white d-flex align-items-center fw-semibold pe-sm-3"
                  >
                    <IoMdArrowRoundBack /> Back
                  </button>
                </div>
                <div className="d-md-none d-flex justify-content-end">
                  <button
                    onClick={() => navigate(-1)}
                    className="btn btn-info text-white d-flex align-items-center fw-semibold pe-sm-3"
                  >
                    <IoMdArrowRoundBack /> Back
                  </button>
                </div>
              </div>

              <div className="card-body p-0">
                <>
                  <div className="table-responsive">
                    <table className="table table-hover table-bordered text-nowrap">
                      <thead>
                        <tr>
                          <th className="ps-3 sr-no">SR No</th>
                          <th>Code</th>
                          <th className="createdat">Message</th>
                          <th className="createdat">CreatedAt</th>
                          <th className="text-center action">Actions</th>
                        </tr>
                      </thead>

                      <tbody>
                        {loading ? (
                          <tr>
                            <td colSpan={5} height={100}>
                              <div className="text-center">
                                <div className="loader"></div>
                              </div>
                            </td>
                          </tr>
                        ) : !smscampaignshortcutsdata || smscampaignshortcutsdata.length === 0 ? (
                          <tr className="border-bottom-0">
                            <td colSpan={5} height={50}>
                              <div className="text-center">
                                <p className="mb-0 fs-5 fw-semibold">
                                  No data found
                                </p>
                              </div>
                            </td>
                          </tr>
                        ) : (
                          smscampaignshortcutsdata.map((item, index) => (
                            <tr key={item.id}>
                              <td className="ps-3">
                                {(currentPage - 1) * limit + index + 1}
                              </td>
                              <td>{item.code}</td>
                              <td>{item.message}</td>
                              <td>{formatDate(item.createdAt)}</td>
                              <td className="text-center">
                                <Link
                                  to={`/admin/sms-campaigns/view/sms-campaigns-Shortcuts/view/${item.id}`}
                                >
                                  <button className="ms-1 bg-transparent border-0 text-success fs-5">
                                    <i data-tooltip-id={"View_Btn_" + index} className="fa-solid fa-eye"></i>
                                    <HelpText id={"View_Btn_" + index} content="View SMS Campaign Shortcut" />
                                  </button>
                                </Link>
                                <button
                                  onClick={() =>
                                    Updateshortcutsrecord(item.id!)
                                  }
                                  className="ms-1 bg-transparent border-0 text-primary fs-5"
                                >
                                  <i data-tooltip-id={"Update_Btn_" + index} className="fa-solid fa-pen"></i>
                                  <HelpText id={"Update_Btn_" + index} content="Update SMS Campaign Shortcut" />
                                </button>
                                <button
                                  onClick={() => openDeleteModal(item.id!)}
                                  className="ms-1 bg-transparent border-0 text-danger fs-5"
                                >
                                  <i data-tooltip-id={"Delete_Btn_" + index} className="fa-solid fa-trash"></i>
                                  <HelpText id={"Delete_Btn_" + index} content="Delete SMS Campaign Shortcut" />
                                </button>
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>

                  {!smscampaignshortcutsdata || smscampaignshortcutsdata.length === 0 ? (
                    <div></div>
                  ) : (
                    <div className="pagination d-flex flex-wrap justify-content-center align-items-center my-4 mx-3">
                      <RenderPaginationButtons
                        info={info}
                        currentPage={currentPage}
                        handlePageChange={handlePageChange}
                      />
                    </div>
                  )}
                </>
              </div>
            </div>
          </div>
        </section>

        <Modal show={showDeleteModal} onHide={closeDeleteModal} centered>
          <div className="p-3">
            <div className="text-center">
              <i
                style={{ fontSize: "50px" }}
                className="text-danger bi bi-info-circle"
              ></i>
            </div>
            <Modal.Header className="d-block border-0 p-2 text-center">
              <Modal.Title>Confirm Delete</Modal.Title>
            </Modal.Header>
            <Modal.Body className="border-0 text-center p-2">
              Are you sure you want to delete this SMS Campaign Shortcuts
            </Modal.Body>
            <Modal.Footer className="border-0 justify-content-center">
              <button className="btn btn-danger" onClick={confirmDelete}>
                Delete
              </button>
              <button className="btn btn-secondary" onClick={closeDeleteModal}>
                Cancel
              </button>
            </Modal.Footer>
          </div>
        </Modal>
      </div>
    </div>
  );
}

export default Shortcuts;
